import apiService from "./apiService";

const emergencyService = {
        async sendDistressSignal(data){
            try{
                const response = await apiService.post(`emergency/send-distress`,data,true);
                return response.data;
            }
            catch(error){
               if (error.response && error.response.status === 503) {
                return {
                    success: false,
                    message: "You're making requests too frequently. Please wait a moment before trying again.",
                };
            }
            return { success: false, message: "An error occured while processing the request" };
            }
        },
}

export default emergencyService;